import { finalize } from 'rxjs/operators';
import { DxDataGridComponent, DxValidationGroupComponent } from 'devextreme-angular';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MapaService } from './../../../../services/mapa.service';
import { DatePipe } from '@angular/common';
import { TelefonosService } from './../../../../services/telefonos.service';
import { TelefonoHistoricoPosiciones } from './../../../../../../_entities/telefonos/telefono';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { GPS, GSM } from './../../../../../../_entities/estados';
import { ToastrService } from 'ngx-toastr';
import { environment } from './../../../../../../../environments/environment';

@Component({
	selector: 'kt-historico-posiciones-telefono',
	templateUrl: './historico-posiciones-telefono.component.html',
	styleUrls: ['./historico-posiciones-telefono.component.scss']
})
export class HistoricoPosicionesTelefonoComponent implements OnInit {
	@ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
	@ViewChild('targetGroup', { static: false }) validationGroup: DxValidationGroupComponent;

	loadingVisible = false;

	public reportePos: TelefonoHistoricoPosiciones[];
	public usuario;
	public idTelefono;
	public telefono;
	public idUsuario;
	public reporteQ: any;
	public fechaInicial;
	public fechaFinal;
	public fechaFin;
	public fechaInicio;
	public datosReporte = [];
	public isDisabled: boolean = true;
	public showTable: boolean = false;


	public showFilterRow: boolean;
	constructor(private telefonosService: TelefonosService,
		private mapaService: MapaService,
		private toastService: ToastrService,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) public data,
		public dialogRef: MatDialogRef<HistoricoPosicionesTelefonoComponent>,
		private datepipe: DatePipe) {
		this.showFilterRow = true;
		this.orderHeaderFilter = this.orderHeaderFilter.bind(this);
	}

	ngOnInit() {
		if (JSON.parse(sessionStorage.getItem('historico'))) {
			this.reportePos = JSON.parse(sessionStorage.getItem('historico'));
			this.telefono = JSON.parse(sessionStorage.getItem('data'));
			this.reportePos.forEach(reporte => {
				let link = `${environment.EXTERNAL_MAP}/ubicar?lat=${reporte.lat}&lng=${reporte.lng}`

				this.datosReporte.push({
					'Ubicacion': {
						f: '=HYPERLINK("' + link + '","Ubicar")',
						v: link
					},
					'Fecha y Hora': reporte.fechaHora,
					'IMEI': reporte.imei,
					'Descripción': reporte.descripcion,
					'Batería': reporte.bateria,
					'Alimentación': reporte.alimentacion,
					'Movimiento': reporte.movimiento,
					'GPS': reporte.gps,
					'GSM': reporte.gsm,
					'Latitud': reporte.lat,
					'Longitus': reporte.lng
				});
			});
			if (this.datosReporte.length > 0) {
				this.isDisabled = false;
				this.showTable = true;
			}

		} else {
			this.telefono = this.data;
		}
	}

	obtenerReportePosiciones(fechaInicio, fechaFin) {
		if (this.validationGroup.instance.validate().isValid) {
			this.loadingVisible = true;
			this.fechaInicial = this.datepipe.transform(fechaInicio, "yyyy-MM-dd HH:mm:ss");
			this.fechaFinal = this.datepipe.transform(fechaFin, "yyyy-MM-dd HH:mm:ss");
			this.mapaService.historicoFechas = [this.fechaInicial, this.fechaFinal]
			this.mapaService.tipoProducto = 'telefono';
			this.reportePos = [];
			this.telefonosService.obtenerReportePosiciones(this.telefono.imei, this.fechaInicial, this.fechaFinal).pipe(
				finalize(() => this.loadingVisible = false)
			).subscribe(
				(telefonos: TelefonoHistoricoPosiciones[]) => {
					if (telefonos.length > 0) {
						telefonos.map(telefono => {
							telefono.estado = telefono.estatus;
							telefono.tipo = 'telefono';
							telefono.direccion = 1;
							telefono.fechaHora = this.datepipe.transform(telefono.fechaHora, 'dd/MM/yyyy hh:mm:ss a');
							telefono.bateria = telefono.bateria + '%'

							switch (telefono.alimentacion) {
								case 0:
									telefono.alimentacion = 'Sin Energía';
									break;
								case 1:
									telefono.alimentacion = 'Energizado';
									break;
								default:
									break;
							}

							if (telefono.estatus == 0) {
								telefono.estatus = 'Inactivo';
							} else {
								telefono.estatus = 'Activo';
							}


							switch (telefono.movimiento) {
								case 0:
									telefono.movimiento = 'Sin Movimiento';
									telefono.icono = './assets/media/marcadores/flechaGris.png'

									break;
								case 1:
									telefono.movimiento = 'En Movimiento';
									telefono.icono = './assets/media/marcadores/flechaVerde.png';
									break;
								default:
									telefono.movimiento = 'Sin Movimiento';
									telefono.icono = './assets/media/marcadores/flechaGris.png'
									break;
							}


							const alertaGSM = GSM.find(gsm => telefono.gsm == gsm.id);
							telefono.gsm = alertaGSM.nombre;
							try {
								const alertaGPS = GPS.find(gps => telefono.gps == gps.id);
								telefono.gps = alertaGPS.nombre;
							} catch (error) {
								telefono.gps = 'Mala';
							}
						})

						this.reportePos = telefonos;
						sessionStorage.setItem('historico', JSON.stringify(this.reportePos));
						sessionStorage.setItem('data', JSON.stringify(this.telefono))

						this.mapaService.posicionesReporte = telefonos;
						this.mapaService.datosGenerales = this.telefono;
						this.mapaService.pintarMarcadoresHistorico();
						var botonesRecorrido = document.getElementById('botonesRecorrido');
						//botonesRecorrido.style.display = 'block';
						this.mapaService.estadoHistorico = true;
						this.mapaService.validarEstadoHistorico();
						this.mapaService.abrirPopupRecorrido();
						this.cerrarPopup();
					} else {
						this.toastService.info('No existen datos disponibles')
					}

				}
			);
		} else {
			this.toastService.warning('Existen campos requerídos vacíos')
		}
	}

	reporteAlDia() {
		this.loadingVisible = true;

		let fechaInicial = new Date().toString();
		fechaInicial = this.datepipe.transform(fechaInicial, 'yyyy-MM-dd 00:00:00');

		let fechaFinal = new Date().toString();
		fechaFinal = this.datepipe.transform(fechaFinal, 'yyyy-MM-dd HH:mm:ss');

		this.mapaService.historicoFechas = [fechaInicial, fechaFinal]
		this.mapaService.tipoProducto = 'telefono';
		this.reportePos = [];

		this.telefonosService.obtenerReportePosiciones(this.telefono.imei, fechaInicial, fechaFinal).pipe(
			finalize(() => this.loadingVisible = false)
		).subscribe(
			(telefonos: TelefonoHistoricoPosiciones[]) => {
				if (telefonos.length > 0) {
					telefonos.map(telefono => {
						telefono.estado = telefono.estatus;
						telefono.tipo = 'telefono';
						telefono.direccion = 1;
						telefono.fechaHora = this.datepipe.transform(telefono.fechaHora, 'dd/MM/yyyy hh:mm:ss a');
						telefono.bateria = telefono.bateria + '%'

						switch (telefono.alimentacion) {
							case 0:
								telefono.alimentacion = 'Sin Energía';
								break;
							case 1:
								telefono.alimentacion = 'Energizado';
								break;
							default:
								break;
						}

						if (telefono.estatus == 0) {
							telefono.estatus = 'Inactivo';
						} else {
							telefono.estatus = 'Activo';
						}


						switch (telefono.movimiento) {
							case 0:
								telefono.movimiento = 'Sin Movimiento';
								telefono.icono = './assets/media/marcadores/flechaGris.png'
								break;
							case 1:
								telefono.movimiento = 'En Movimiento';
								telefono.icono = './assets/media/marcadores/flechaVerde.png';
								break;
							default:
								telefono.movimiento = 'Sin Movimiento';
								telefono.icono = './assets/media/marcadores/flechaGris.png'
								break;
						}


						const alertaGSM = GSM.find(gsm => telefono.gsm == gsm.id);
						telefono.gsm = alertaGSM.nombre;
						try {
							const alertaGPS = GPS.find(gps => telefono.gps == gps.id);
							telefono.gps = alertaGPS.nombre;
						} catch (error) {
							telefono.gps = 'Mala';
						}
					})

					this.reportePos = telefonos;
					sessionStorage.setItem('historico', JSON.stringify(this.reportePos));
					sessionStorage.setItem('data', JSON.stringify(this.telefono))

					this.mapaService.posicionesReporte = telefonos;
					this.mapaService.datosGenerales = this.telefono;
					this.mapaService.pintarMarcadoresHistorico();
					var botonesRecorrido = document.getElementById('botonesRecorrido');
					//botonesRecorrido.style.display = 'block';
					this.mapaService.estadoHistorico = true;
					this.mapaService.validarEstadoHistorico();
					this.mapaService.abrirPopupRecorrido();
					this.cerrarPopup();
				} else {
					this.toastService.info('No existen datos disponibles')
				}

			}
		);

	}

	clearFilter() {
		this.dataGrid.instance.clearFilter();
	}

	public ubicarPuntoHistorico(data) {
		this.mapaService.ubicarPuntoHistorico(data);
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}
	orderHeaderFilter(data) {
		data.dataSource.postProcess = (results) => {
			results.push({
				text: "Weekends",
				value: "weekends"
			});
			return results;
		};
	}

}
